import React, { useState, useRef } from "react";
import Papa from "papaparse";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloudUpload from "@mui/icons-material/CloudUpload";
import UploadFile from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import Badge from "@mui/material/Badge";

const CSVUploader = ({ onFileLoad }) => {
  const fileInputRef = useRef(null);
  const [fileUploaded, setFileUploaded] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          onFileLoad(result.data, fileInputRef);
          setFileUploaded(true);
        },
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
      });
    }
  };

  const handleClearFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setFileUploaded(false);
  };

  return (
    <Box
      sx={{ margin: "10px 0" }}
      display={"flex"}
      alignItems={"center"}
      gap={2}
    >
      {!fileUploaded ? (
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          fullWidth
          sx={{ fontSize: "10px" }}
          startIcon={<UploadFile />}
        >
          Upload CSV file
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            ref={fileInputRef}
            style={{ display: "none" }} // Hide the input element
          />
        </Button>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              position: "relative",
            }}
          >
            <Typography sx={{ color: "green" }} variant="body1">
              File Uploaded
            </Typography>
            <img src="/assets/check.png" width={30} alt="Success check" />
          </Box>
          <Button color="error" variant="outlined" onClick={handleClearFile}>
            <DeleteIcon color="error" />
          </Button>
        </>
      )}
    </Box>
  );
};

export default CSVUploader;